var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.sale)?_c('div',{staticClass:"custom-card card-payment-plan p-15 m-b-15"},[_c('p',[_vm._v(" Venta N° "+_vm._s(_vm.sale.num)+" ")]),_c('p',[_vm._v(" Total: "),_c('strong',[_vm._v(_vm._s(_vm.price(_vm.sale.total)))])]),(_vm.sale.client)?_c('p',[_vm._v(" Cliente: "),_c('strong',[_vm._v(_vm._s(_vm.sale.client.name))])]):_vm._e()]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }